import { render, staticRenderFns } from "./trade-price-batch-info.vue?vue&type=template&id=79d7629a&"
import script from "./trade-price-batch-info.vue?vue&type=script&lang=js&"
export * from "./trade-price-batch-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "trade-price-batch-info.vue"
export default component.exports